import axios from 'axios';
import qs from 'qs';

export let baseUrl = '/api';// 代理
if (window.location.hostname == 'm0.eicchannel.com') {
	baseUrl = 'https://m0.eicchannel.com' // 测试
} else if (window.location.hostname == 'm.eicchannel.com') {
	baseUrl = 'https://m.eicchannel.com' // 正式
}

// console.log(window.location.hostname)
const POST = (url, params, opt) => {
	return axios.post(`${url}`, qs.stringify(params), opt).then(res => res.data).catch(err => console.log(err));
}

const GET = (url, params) => {
	return axios.get(`${url}`, params).then(res => res.data).catch(err => console.log(err));
}


export const sendCode = data => GET(baseUrl + '/expo/sendCode', data)  // 发送验证码

export const login = (data, opt) => POST(baseUrl + '/expo/login', data, opt)  // 登录

export const userLoginStatus = (data, opt) => POST(baseUrl + '/expo/loginStatus', data, opt)  // 判断登录状态

export const getLiveDetail = data => GET(baseUrl + '/expo/getLiveDetail', data)  // 获取直播列表

export const getSchoolList = data => GET(baseUrl + '/expo/getSchoolGuest', data)  // 学校列表

export const getUpsTeacher = data => GET(baseUrl + '/expo/getUpsTeacher', data)  // 大咖列表

export const getCurrentLive = data => GET(baseUrl + '/expo/getCurrentLive', data)  // 正在直播列表

export const getAdv = data => GET(baseUrl + '/expo/getAdv', data)  // 获取广告位

export const teacherSubscribe = (data, opt) => POST(baseUrl + '/expo/teacherSubscribe', data, opt)  // 大咖预约接口

export const guestSubscribe = (data, opt) => POST(baseUrl + '/expo/guestSubscribe', data, opt)  // 院校代表预约

export const signActivity = (data, opt) => POST(baseUrl + '/expo/sign', data, opt)  // 签到

export const getPrize = (data, opt) => POST(baseUrl + '/expo/participateDraw', data, opt)  // 逛展抽奖

export const getSignPrize = (data, opt) => POST(baseUrl + '/expo/contractDraw', data, opt)  // 签约抽奖

export const getPrizeInfoList = data => GET(baseUrl + '/expo/getParticipateDraw', data)  // 逛展抽奖信息

export const getSignPrizeInfoList = data => GET(baseUrl + '/expo/getContractDraw', data)  // 签约抽奖信息

export const getDrawTime = data => GET(baseUrl + '/expo/getDrawTime', data)  // 抽奖次数

export const getExpoInfo = data => GET(baseUrl + '/expo/getExpoInfo', data)  // 展会信息接口

export const getOfficial = data => GET(baseUrl + '/expo/getOfficialRelease', data)  // 官方发布区

export const adviserSubscribe = (data, opt) => POST(baseUrl + '/expo/adviserSubscribe', data, opt)  // 顾问预约接口

export const getAdviser = data => GET(baseUrl + '/expo/getAdviser', data)  // 顾问列表接口

export const getCountry = data => GET(baseUrl + '/expo/getProjectLine', data)  // 顾问列表项目线接口

export const getCityList = data => GET(baseUrl + '/expo/getCityList', data)  // 获取城市列表

export const getIpToCity = data => GET(baseUrl + '/expo/getIpToCity', data)  // 获取城市列表

export const getTeacherList = data => GET(baseUrl + '/expo/getTeacherList', data)  // 大咖二级页面列表接口

export const checkAdviserSubscribe = (data, opt) => POST(baseUrl + '/expo/checkAdviserSubscribe', data, opt)  // 判断顾问是否已经预约

export const checkGuestSubscribe = (data, opt) => POST(baseUrl + '/expo/checkGuestSubscribe', data, opt)  // 判断院校嘉宾是否已经预约

export const checkTeacherSubscribe = (data, opt) => POST(baseUrl + '/expo/checkTeacherSubscribe', data, opt)  // 判断大咖是否已经预约

